var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 37.75C11.952 35.5055 9.5129 33.0448 7.29167 30.3937C3.95833 26.4125 1.83103e-06 20.4833 1.83103e-06 14.8333C-0.00144379 11.9478 0.853144 9.12675 2.45561 6.72713C4.05808 4.3275 6.3364 2.45719 9.00222 1.3529C11.668 0.248606 14.6016 -0.0400323 17.4315 0.523513C20.2614 1.08706 22.8606 2.47745 24.9 4.51874C26.2578 5.87053 27.334 7.47819 28.0664 9.24868C28.7988 11.0192 29.1728 12.9173 29.1667 14.8333C29.1667 20.4833 25.2083 26.4125 21.875 30.3937C19.6537 33.0448 17.2147 35.5055 14.5833 37.75ZM14.5833 8.58332C12.9257 8.58332 11.336 9.2418 10.1639 10.4139C8.99181 11.586 8.33333 13.1757 8.33333 14.8333C8.33333 16.4909 8.99181 18.0806 10.1639 19.2527C11.336 20.4248 12.9257 21.0833 14.5833 21.0833C16.2409 21.0833 17.8306 20.4248 19.0027 19.2527C20.1748 18.0806 20.8333 16.4909 20.8333 14.8333C20.8333 13.1757 20.1748 11.586 19.0027 10.4139C17.8306 9.2418 16.2409 8.58332 14.5833 8.58332Z",
    fill: "#0FA958"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.0184046e7d3bc9d6ebcdff91e93aa1df.svg";
export { ForwardRef as ReactComponent };